import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import {
  numberWithComma,
  formatDateWithoutTime,
  formatShippingTypes,
  getSupplierPaymentType,
  formatDateTime,
  currentDateTimeThaiformat,
} from 'helpers/format'
import { Col, Divider, Image, Row, Space } from 'antd'
import { QuotationProduct } from 'Store/quotation/types'
import { appConfig } from 'config'
import { ImageFallback } from 'helpers/constanst'
import PdfCompanyInfo from 'Pages/Purchase/components/PdfCompanyInfo'
// import QuotationSummay from 'Pages/SupplierOrder/components/QuotationSummay'
import { PatialDetail } from 'Store/supplier-invoice/types'
import { PdfPrintFormat, PdfPrintLiteFormat } from 'Components/form'
import { ThaiBaht } from 'thai-baht-text-ts'
import QuotationSummay from 'Pages/Quotation/components/QuotationSummay'

type Props = {
  detail?: PatialDetail
  remailAmount?: number
  isLite?: boolean
}

const SaleInvoicePDF: React.FunctionComponent<Props> = props => {
  const { detail, remailAmount = 0, isLite = false } = props
  const bill = detail?.partial

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderInfoItem = (title: any, value: any, justify: 'start' | 'end' = 'start') => {
    return (
      <Row gutter={[8, 8]} justify={justify}>
        <Col>
          <Space wrap={true}>
            <InfoTitle>
              {title} : {value || '-'}
            </InfoTitle>
          </Space>
        </Col>
      </Row>
    )
  }

  const renderCustomerInfo = () => {
    return (
      <div>
        {renderInfoItem('ชื่อลูกค้า', detail?.recipient_name)}
        {renderInfoItem('ที่อยู่จัดส่ง', detail?.recipient_address)}
        {renderInfoItem('เบอร์โทรศัพท์', detail?.recipient_mobile)}
        {renderInfoItem('อีเมล', detail?.recipient_email)}
        {renderInfoItem('ขนส่งโดย', formatShippingTypes(detail?.delivery_channel || ''))}
      </div>
    )
  }

  const renderPurchaseInfo = () => {
    return (
      <div>
        {renderInfoItem('เลขที่ใบเสร็จ', bill?.receipt_no, 'end')}
        {renderInfoItem('เลขที่สั่งซื้อ', detail?.sale_order_no, 'end')}
        {renderInfoItem('วันที่สั่งซื้อ', formatDateWithoutTime(detail?.created_at || ''), 'end')}
        {renderInfoItem('วันที่จัดส่งสำเร็จ', formatDateWithoutTime(detail?.delivered_dt || ''), 'end')}
        {renderInfoItem('วันที่พิมพ์', currentDateTimeThaiformat(), 'end')}
      </div>
    )
  }

  const renderProductName = (item: any, record: QuotationProduct) => {
    const isSameTitle = record.title == record.product_option_title
    return (
      <>
        <RowTile>{record.title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
      </>
    )
  }

  const renderImage = (item: QuotationProduct) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + item.picture} fallback={ImageFallback} />
  )

  const renderTotalPrice = (item: QuotationProduct) => {
    return (item.quantity || 0) * (item.price || 0)
  }

  const summaryFooter = (
    <Row justify="space-between">
      <Col span={12}>{renderInfoItem('หมายเหตุ', bill?.reason)}</Col>
      <Col span={12}>
        <QuotationSummay detail={detail} />
        <Divider style={{ margin: '10px 0', background: '#000' }} />
      </Col>
      <Col span={24}>
        <Row>
          <Col span={12}>
            <InfoTitle style={{ textAlign: 'left' }}>
              ยอดชำระ (ตัวอักษร) {ThaiBaht(bill?.amount || 0)}
            </InfoTitle>
          </Col>
          <Col span={12}>
            <Row justify="space-between">
              <Col>
                <InfoTitle>ยอดชำระ</InfoTitle>
              </Col>
              <Col>
                <InfoTitle>
                  {bill?.payment_channel === 'void' ? '-' : ''}
                  {numberWithComma(bill?.amount || 0, true)} บาท
                </InfoTitle>
              </Col>
            </Row>
            {remailAmount > 0 && (
              <Row justify="space-between">
                <Col>
                  <InfoTitle>ยอดค้างชำระ</InfoTitle>
                </Col>
                <Col>
                  <InfoTitle>{numberWithComma(remailAmount || 0, true)} บาท</InfoTitle>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )

  const moreFooter = (
    <Row justify="start">
      <Col span={24}>
        {renderInfoItem(
          'ประเภทการชำระ',
          `${bill?.payment_type === 'partial' ? 'แบ่งชำระ' : 'ชำระเต็มจำนวน'}`,
        )}
      </Col>
      <Col span={24}>
        {renderInfoItem('รูปแบบการชำระเงิน', getSupplierPaymentType(bill?.payment_channel))}
      </Col>
      <Col span={24}>{renderInfoItem('วันที่ชำระเงิน', formatDateTime(bill?.payment_date || ''))}</Col>
    </Row>
  )

  const tableHeader = (
    <thead>
      <th>ลำดับ</th>
      {/* <th className="left">รหัสสินค้า</th> */}
      <th style={{ width: '50px' }}>รูปภาพ</th>
      <th className="left">รหัสสินค้า</th>
      <th style={{ width: '30%' }} className="left">
        รายการ
      </th>
      <th className="left">ยี่ห้อ</th>
      <th>จำนวน</th>
      <th>หน่วย</th>
      <th className="right">ราคา/หน่วย</th>
      <th className="right">ราคารวม</th>
    </thead>
  )

  const tableBody = (
    <tbody>
      {detail?.products &&
        detail.products.map((item: QuotationProduct, index: number) => {
          return (
            <tr key={index}>
              <td>{renderInfo(index + 1)}</td>
              <td>{renderImage(item)}</td>
              <td className="left">{renderInfo(item?.code || '-')}</td>
              <td className="left">{renderProductName(item?.title, item)}</td>
              <td className="left">{renderInfo(item?.brand || '-')}</td>
              <td>{renderInfo(numberWithComma(item?.quantity))}</td>
              <td>{renderInfo(item?.unit || '-')}</td>
              <td className="right">{renderInfo(numberWithComma(item?.price || 0, true))}</td>
              <td className="right">{renderInfo(numberWithComma(renderTotalPrice(item), true))}</td>
            </tr>
          )
        })}
    </tbody>
  )

  return isLite ? (
    <PdfPrintLiteFormat
      companyInfo={<PdfCompanyInfo merchant={detail?.merchant} />}
      title={`ใบเสร็จรับเงิน`}
      leftInfo={renderCustomerInfo()}
      rightInfo={renderPurchaseInfo()}
      footerSpan={9}
      summaryFooter={summaryFooter}
      signPosition={['ผู้รับเงิน', 'ผู้รับสินค้า']}
      thead={tableHeader}
      tbody={tableBody}
      moreFooter={moreFooter}
    />
  ) : (
    <PdfPrintFormat
      companyInfo={<PdfCompanyInfo merchant={detail?.merchant} />}
      title={`ใบเสร็จรับเงิน`}
      leftInfo={renderCustomerInfo()}
      rightInfo={renderPurchaseInfo()}
      footerSpan={9}
      summaryFooter={summaryFooter}
      signPosition={['ผู้รับเงิน', 'ผู้รับสินค้า']}
      thead={tableHeader}
      tbody={tableBody}
      moreFooter={moreFooter}
    />
  )
}

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const InfoTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  white-space: pre-line;
  text-align: left;
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 40px;
  height: 40px;
  object-fit: contain;
`

export default SaleInvoicePDF
